import { AxiosError } from 'axios'
import { ENDPOINT_SUPER_AGENT } from '../config'
import type { OnboardSuperAgentRequest, SuperAgentStatusResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const onboardSuperAgent = async (
  workspaceSlug: string,
  projectId: string,
  request: OnboardSuperAgentRequest,
): Promise<SuperAgentStatusResponse> => {
  try {
    const response = await AuthAxios.post<SuperAgentStatusResponse>(
      `${ENDPOINT_SUPER_AGENT}/${workspaceSlug}/projects/${projectId}/super-agent/onboard`,
      request,
    )
    return response.data
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 403) {
      throw new Error('Enable AI for this workspace before activating the Super Agent.')
    }
    throw error
  }
}

export default onboardSuperAgent
